import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { authServices } from '../authServices'
import { SetupProfileDTO, SetupProfilePayload } from '../authTypes'
import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useSetupProfile = (
  options?: IOptionsUseMutation<SetupProfileDTO>,
) => {
  const { t } = useTranslation()

  return useMutation<SetupProfileDTO, ErrorDetail, SetupProfilePayload>({
    mutationFn: authServices.setupProfile,
    onSuccess: (data: SetupProfileDTO) => {
      if (options?.onSuccess) {
        options?.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.ACTION_IS_NOT_ALLOWED) {
        errorMessage = t('api:yourAccountIsDeleted')
      }

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (code === ApiErrorCode.REFERRAL_CODE_NOT_FOUND) {
        errorMessage = t('api:errors.referralCodeNotFound')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })
}
